import React from 'react'
import cx from 'classnames'

import type { BoxSize } from 'components/_new/layout'

import { Box } from 'components/_new/layout'
import Text, { Color, Size as TextSize } from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './HrLine.scss'


const lineColors = [ 'white' ] as const

type HrLineProps = {
  or?: boolean
  mt?: BoxSize
  mb?: BoxSize
  size?: TextSize
  color?: Color
  message?: ReactIntlMessage | string
  lineColor?: typeof lineColors[number]
}

const HrLine: React.FunctionComponent<HrLineProps> = (props) => {
  const { or, message, size = '14-24', color = 'gray-50', lineColor, mt = 24, mb = 24 } = props

  const lineClassName = cx(s.line, s[`${lineColor}Line`])

  return (
    <Box className={s.container} mt={mt} mb={mb}>
      <div className={lineClassName} />
      {
        Boolean(or || message) && (
          <Text
            className={s.text}
            size={size}
            color={color}
            message={message || messages.or}
          />
        )
      }
      <div className={lineClassName} />
    </Box>
  )
}


export default HrLine
